/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const BillingPage = lazyLoad(
  () => import('./index'),
  module => module.BillingPage
);
